module.exports = __webpack_public_path__ + "img/21008-social-media-concept.4e7c06f1.gif";